import { useTranslation } from "react-i18next";
import { RiNotificationOffLine } from "react-icons/ri";
import InfiniteScroll from "react-infinite-scroll-component";
import NotificationCard from "./NotificationCard";
import IconComponent from "@CubeComponents/icons";
import CheckBoxComponent from "@CubeComponents/Mui_Form/CheckBox";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { useAllNotification } from "./useAllNotification";

const SCROLL_TARGET_ID = "notifications-scroll-container";

interface Props {
  closeNotificationModal: () => void;
}

function AllNotification({ closeNotificationModal }: Props) {
  const { t } = useTranslation();
  const {
    notifications,
    showEmptyState,
    selectedIds,
    allSelected,
    majorityIsUnread,
    iconTypeMap,
    hasMore,
    loadMore,
    dismissNotification,
    toggleReadState,
    toggleSelect,
    selectAll,
    clearSelection,
    markSelected,
  } = useAllNotification();

  return (
    <>
      {notifications.length > 0 && selectedIds.size > 0 && (
        <div className="flex items-center justify-between px-6 py-2">
          <CheckBoxComponent
            label={t("Select all") as unknown as string}
            checked={allSelected}
            indeterminate={selectedIds.size > 0 && !allSelected}
            onChange={(_args: any, checked: boolean) => (checked ? selectAll() : clearSelection())}
          />
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} type="button" onClick={markSelected}>
            {majorityIsUnread ? t("Mark as read") : t("Mark as unread")}
          </ButtonComponent>
        </div>
      )}

      <div id={SCROLL_TARGET_ID} className="flex-1 overflow-y-auto overscroll-none">
        {showEmptyState ? (
          <div className="flex flex-col items-center justify-center py-8">
            <RiNotificationOffLine className="m-auto h-[6.25rem] w-[6.25rem] fill-[#a9dff9]" />
            <p className="mt-2.5 text-center">{t("No Notifications right now!")}</p>
          </div>
        ) : (
          <InfiniteScroll
            dataLength={notifications.length}
            next={loadMore}
            hasMore={hasMore}
            style={{ overflow: "visible" }}
            loader={
              <div className="flex justify-center py-3">
                <IconComponent name="loader-icon" width="1.5rem" height="1.5rem" className="w-5 h-5 animate-spin" />
              </div>
            }
            endMessage={
              notifications.length > 0 ? (
                <div className="text-center text-xs text-gray-400 py-3">{t("You're all caught up")}</div>
              ) : null
            }
            scrollableTarget={SCROLL_TARGET_ID}
            scrollThreshold="90%"
          >
            <NotificationCard
              notifications={notifications}
              iconTypeMap={iconTypeMap}
              dismissNotification={dismissNotification}
              toggleReadState={toggleReadState}
              closeNotificationModal={closeNotificationModal}
              selectedIds={selectedIds}
              onToggleSelect={toggleSelect}
            />
          </InfiniteScroll>
        )}
      </div>
    </>
  );
}

export default AllNotification;
